









































































































import '@/assets/css/components/filter-dropdown.scss';

import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import Inputmask from 'inputmask';

import Search from '@/components/Search.vue';
import SelectCustom from '@/components/select/SelectCustom.vue';
import MultiSelect from '@/components/multiselect/MultiSelectEntity.vue';
import Checkbox from '@/components/checkbox/CheckboxFilter.vue';
import CheckboxUnion from '@/components/checkbox/CheckboxUnion.vue';
import DatepickerPopup from '@/components/datepicker/DatepickerPopup.vue';
import RadioSwitch from '@/components/radio/RadioSwitch.vue';

import { directive as clickOutside } from 'v-click-outside';

import UserModule from '@/store/user';
import FilterModal from '@/store/modals/filter';

import { FilterSettings } from '@/types/filter/filter';
import { FilterSelectInterface } from '@/types/filter/filterSelect';
import { FilterAutocompleteInterface } from '@/types/filter/filterAutocomplete';
import { FilterDatePickerInterface } from '@/types/filter/filterDatePicker';

import { FilterType } from '@/types/filter/filter';

import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faTimes, faTimesCircle } from '@fortawesome/free-solid-svg-icons';

library.add(faTimes, faTimesCircle);

@Component({
    components: {
        FontAwesomeIcon,
        Search,
        SelectCustom,
        MultiSelect,
        Checkbox,
        CheckboxUnion,
        DatepickerPopup,
        RadioSwitch,
    },
    directives: { clickOutside },
})
export default class FilterDropDown extends Vue {
    @Prop({ required: true }) readonly settings!: FilterSettings;
    @Prop({ required: true }) readonly handlers?: any;
    @Prop({ required: false, default: () => ({}) }) readonly filters!: Record<string, any>;
    @Prop({ required: false }) readonly focusKey?: string;

    @Watch('isShow')
    onIsShowChange(val: boolean) {
        if (val) {
            this.setListeners();
            this.focusSearchInput();
            this.$nextTick(this.addMasks);

            return;
        }
        this.resetListeners();
    }

    get isShow() {
        return FilterModal.modal.isShow;
    }

    get FilterType() {
        return FilterType;
    }

    get availableFilters() {
        return Object.fromEntries(
            Object.entries(this.filters).filter(
                ([, filter]) => filter.roles.length === 0 || filter.roles.includes(UserModule.role)
            )
        )
    }

    closeModal() {
        FilterModal.closeModal();
        this.$store.dispatch(this.handlers?.resetState);
    }

    handleSelect(selected: { id: number; value: string }, filter: FilterSelectInterface) {
        filter.current = selected;

        this.$store.dispatch(filter.action, {
            key: filter.key,
            value: selected,
        });
    }

    resetSelect(filter: FilterSelectInterface) {
        this.$store.dispatch(filter.clearAction, filter.key);
    }

    handleAutocomplete(selected: { id: number; value: any }, filter: FilterAutocompleteInterface) {
        filter.current = selected;

        this.$store.dispatch(filter.action, {
            key: filter.key,
            value: selected.id
        });
    }

    handleMultiSelect(data: { key: number; selected: { id: number; value: string } }, handlerName: string) {
        this.$store.dispatch(handlerName, data);
    }

    handleDateSelection(date: string, filter: FilterDatePickerInterface) {
        this.$store.dispatch(filter.action, date);
    }

    clearDate(clearAction: string) {
        this.$store.dispatch(clearAction, {}, { root: true });
    }

    async executeClear() {
        FilterModal.closeModal();
        // await FilterSettings.resetFilter();
        // await this.$store.dispatch(this.handlers.reset, {}, { root: true });
        this.$emit('resetFilters');
    }

    async executeYes() {
        FilterModal.closeModal();
        // await this.$store.dispatch(this.handlers.update, {}, { root: true });
        // await this.settings.updateFilter();
        this.$emit('updateList');
    }

    setListeners() {
        document.addEventListener('keyup', this.listenerHandler);
    }

    resetListeners() {
        document.removeEventListener('keyup', this.listenerHandler);
    }

    listenerHandler(e: KeyboardEvent) {
        if (e.key === 'Enter' || e.keyCode === 13) {
            this.executeYes();
        }

        if (e.key === 'Esc' || e.keyCode === 27) {
            this.executeClear();
        }
    }

    async focusSearchInput() {
        const searchFilters = Object.values(this.settings.filterModel);

        if (searchFilters.length === 0) return;

        const filterItem = searchFilters.find(el => el.key === this.focusKey);
        const targetFilter = filterItem || (searchFilters[0] as any);

        let el: any = null;

        if (targetFilter.class) {
            await this.$nextTick();
            el = document.querySelector(`.${targetFilter.class} input`) as HTMLElement;
        }

        if (!el && targetFilter.placeholder) {
            await this.$nextTick();
            el = document.querySelector(
                `.mr-search-input__wrapper input[placeholder="${targetFilter.placeholder}"]`,
            ) as HTMLElement;
        }

        if (el) {
            el.focus();
        }
    }
    addMasks() {
        Object.values(this.settings.filterModel).forEach((item: any) => {
            if (item.mask) {
                const settingsMask = new Inputmask(item.mask);
                const inputs = document.getElementsByClassName(item.class);

                for (const input of Object.values(inputs)) {
                    settingsMask.mask(input.getElementsByTagName('input'));
                }
            }
        });
    }
    clearSelect(data: { clearAction: string; key: string }) {
        this.$store.dispatch(data.clearAction, data.key);
    }
}
